import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=6bce1d65&scoped=true"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"
import style0 from "./DonationForm.vue?vue&type=style&index=0&id=6bce1d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce1d65",
  null
  
)

export default component.exports